import React, { FC, useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { CurrencyInputProps } from "react-currency-input-field";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { stateProps } from "../types";
import { changePrice } from "../actions";
import { changeCurrency } from "../actions";
import ContainerBox from "./common/containerBox.component";
import FormText from "./form/formText.component";

const options: ReadonlyArray<CurrencyInputProps["intlConfig"]> = [
  {
    locale: "en-LK",
    currency: "LKR",
  },
  {
    locale: "en-US",
    currency: "USD",
  },
  {
    locale: "en-MV",
    currency: "MVR",
  },

  {
    locale: "en-IN",
    currency: "INR",
  },
];

const Price: FC = () => {
  const dispatch = useDispatch();
  const [intlConfig, setIntlConfig] = useState<
    CurrencyInputProps["intlConfig"]
  >(options[0]);

  // const [value, setValue] = useState<string | undefined>("");

  const price = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.price
  );

  const pcurrency = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.pcurrency
  );

  const handleOnValueChange = (value: string | undefined, event: any): void => {
    console.log(value);
    dispatch(changePrice(value));
    // setValue(value);
  };

  const handleIntlSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const config = options[Number(event.target.value)];
    console.log(event.target.value);
    dispatch(changeCurrency(event.target.value));
    if (config) {
      setIntlConfig(config);
    }
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText
          number={"09"}
          title={"How much would you like to charge per consultation?"}
        />
        <Box
          sx={{
            borderStyle: "solid",
            width: { xs: "200px", sm: "300px", md: "407px" },
            height: { xs: "50px", sm: "54px", md: "49px" },
            opacity: 1,
            marginTop: "15px",
            borderColor: "#94949533",
            backgroundColor: "#F8F8F8",
            borderRadius: 2,
            borderWidth: 0.5,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <select
            className="form-control"
            id="intlConfigSelect"
            onChange={handleIntlSelect}
            value={pcurrency}
            style={{
              backgroundColor: "#F8F8F8",
              marginLeft: 20,
              marginRight: 10,
              outline: "none",
              borderColor: "#F8F8F8",
            }}
          >
            {options.map((config, i) => {
              if (config) {
                const { locale, currency } = config;
                return (
                  <option key={`${locale}${currency}`} value={i}>
                    {currency}
                  </option>
                );
              }
              return config;
            })}
          </select>

          <CurrencyInput
            id="validationCustom04"
            name="input-1"
            intlConfig={pcurrency}
            className={`form-control`}
            onValueChange={handleOnValueChange}
            placeholder="Your Charge"
            decimalsLimit={6}
            value={price}
            step={1}
            //prefix={pcurrency}
            style={{
              backgroundColor: "#F8F8F8",
              width: "300px",
              height: "47px",
              border: "#000",
              fontFamily: "Avenir",
              fontSize: "15px",
              lineHeight: "24px",
              outline: "none",
              // borderWidth: 0.5,
              // borderColor: "#ffffff",
              // borderRadius: 4,
            }}
          />
        </Box>
      </ContainerBox>
    </React.Fragment>
  );
};

export default Price;
